import BigNumber from 'bignumber.js';
import { ExchangeRate } from '../../types';

export type DisplayExchangeRate = {
  dominantCurrency: string;
  secondaryCurrency: string;
  exchangeRate: number;
};

/**
 * On the UI we only want to display exchange rates from the side of the dominant currency.
 * This utility helps the UI get the apropriate parts.
 */
export const getDisplayExchangeRate = ({
  dominantCurrency,
  sourceCurrency,
  targetCurrency,
  exchangeRate,
}: ExchangeRate): DisplayExchangeRate => {
  return {
    dominantCurrency,
    secondaryCurrency: dominantCurrency === targetCurrency ? sourceCurrency : targetCurrency,
    exchangeRate: dominantCurrency === targetCurrency ? exchangeRate : new BigNumber(1).div(exchangeRate).toNumber(),
  };
};
